import { render, staticRenderFns } from "./CharacterAdd.vue?vue&type=template&id=4db105b3&scoped=true"
import script from "./CharacterAdd.vue?vue&type=script&lang=js"
export * from "./CharacterAdd.vue?vue&type=script&lang=js"
import style0 from "./CharacterAdd.vue?vue&type=style&index=0&id=4db105b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db105b3",
  null
  
)

export default component.exports